import { render, staticRenderFns } from "./UserManagePage.vue?vue&type=template&id=3b63f43c&"
import script from "./UserManagePage.vue?vue&type=script&lang=js&"
export * from "./UserManagePage.vue?vue&type=script&lang=js&"
import style0 from "./UserManagePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports